import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}

    :host {
        display: inline-block;
        --icon-color: var(--sgdf-color-neutral-600);
    }

    .icon-button {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        background: none;
        border: none;
        border-radius: var(--sl-border-radius-medium);
        font-size: inherit;
        color: var(--icon-color);
        padding: var(--sl-spacing-x-small);
        cursor: pointer;
        transition: var(--sl-transition-medium) color;
        -webkit-appearance: none;
    }

    .icon-button:hover:not(.icon-button--disabled),
    .icon-button:focus:not(.icon-button--disabled) {
        color: var(--sl-color-primary-600);
    }

    .icon-button:active:not(.icon-button--disabled) {
        color: var(--sl-color-primary-700);
    }

    .icon-button:focus {
        outline: none;
    }

    .icon-button--disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .icon-button:focus-visible {
        outline: var(--sl-focus-ring);
        outline-offset: var(--sl-focus-ring-offset);
    }

    .icon-button__icon {
        pointer-events: none;
    }

    .icon-button--border {
        border: solid 1px var(--sl-color-neutral-300);
    }
`;
//# sourceMappingURL=icon-button.styles.js.map